<script>
import { mapActions, mapGetters } from 'vuex';
import downloader from '@/mixins/downloader';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'ProcedureDirectoryListItem',
  mixins: [downloader, snackbarMixin],
  props: {
    procedureDirectory: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('app', ['auth']),
  },
  methods: {
    ...mapActions('procedureDirectoryList', ['downloadReport']),
    onDelete() {
      this.$emit('delete', this.procedureDirectory);
    },
    _downloadReport() {
      return this.downloadReport(this.procedureDirectory.id)
        .then((response) => {
          this.getDownloadContent(response, 'procedure_report.pdf');
        }).catch((error) => {
          console.log(`Fehler: ${error.response}`);
          this.showErrorMessage('Beim Erstellen des Berichts ist ein Fehler aufgetreten.');
        });
    },
  },
};
</script>

<template>
  <tr>
    <td>
      <router-link :to="`/procedureDirectory/show/${procedureDirectory.id}`">
        {{ procedureDirectory.name }}
      </router-link>
    </td>
    <td>
      {{
        procedureDirectory.organizationalUnit ? procedureDirectory.organizationalUnit.name : null
      }}
    </td>
    <td>
      {{ procedureDirectory.responsibleUser ? procedureDirectory.responsibleUser.username : null }}
    </td>
    <td>
      {{ procedureDirectory.examState ? procedureDirectory.examState.name : null }}
    </td>
    <td>
      <v-tooltip bottom>
        <v-btn v-if="auth.hasDownloadRights"
               @click.native="_downloadReport" flat icon slot="activator">
          <v-icon small>cloud_download</v-icon>
        </v-btn>
        <span>Bericht herunterladen</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          v-if="auth.hasDeleteRights"
          slot="activator"
          :disabled="procedureDirectory.isDelete"
          flat icon
          @click.native="onDelete"
        >
          <v-icon small>delete</v-icon>
        </v-btn>
        <span>Löschen</span>
      </v-tooltip>
    </td>
  </tr>
</template>
